import {
    CustomComponentProps,
    PollObject,
    PollType
} from "utils/types/generalTypes";
import SVG from "../core/SVG";
import PollText from "./PollText";
import PollImage from "./PollImage";
import PollDueDate from "./PollDueDate";

export type PollProps = CustomComponentProps & {
    poll: PollObject;
    updatePollType: (type: PollType) => void;
    handleRemoveMedia: () => void;
    updatePollOption: (
        option: string | FileList,
        optionOrder: 0 | 1 | 2
    ) => void;
    handleShowThirdPoll: () => void;
    handleRemoveThirdPoll: () => void;
    updatePollDays: (d: number) => void;
    updatePollHours: (h: number) => void;
    updatePollMinutes: (mins: number) => void;
};

const Poll = ({
    poll,
    updatePollType,
    updatePollOption,
    handleRemoveMedia,
    handleShowThirdPoll,
    handleRemoveThirdPoll,
    updatePollDays,
    updatePollHours,
    updatePollMinutes,
    className,
    style
}: PollProps) => {
    return (
        <div className={`poll post-media-displayer ${className}`} style={style}>
            <div className="signup-wrapper pr-20">
                <div className="process-panel-wrap is-narrow">
                    {/* poll post tabs  */}
                    <div className="tabs is-boxed is-fullwidth">
                        <ul id="post-form-tabs-ul">
                            <li
                                className={`${poll.type == "text" ? "is-active" : " "} post-form-tabs-li`}
                                onClick={() => updatePollType("text")}
                            >
                                <a className="grey-text">Text</a>
                            </li>
                            <li
                                className={`${poll.type == "img" ? "is-active" : ""} post-form-tabs-li`}
                                onClick={() => updatePollType("img")}
                            >
                                <a className="grey-text">Image</a>
                            </li>
                            <li className="close-wrap d-flex flex-j-end mr-10">
                                <span
                                    className="custom-close-modal"
                                    onClick={handleRemoveMedia}
                                >
                                    <SVG svg="x" size={16} />
                                </span>
                            </li>
                        </ul>
                    </div>

                    {/* text poll form  */}
                    {poll.type == "text" ? (
                        <PollText
                            poll={poll}
                            updatePollOption={updatePollOption}
                            handleShowThirdPoll={handleShowThirdPoll}
                            handleRemoveThirdPoll={handleRemoveThirdPoll}
                        />
                    ) : (
                        ""
                    )}

                    {/* img poll form  */}
                    {poll.type == "img" ? (
                        <PollImage
                            poll={poll}
                            updatePollOption={updatePollOption}
                            handleShowThirdPoll={handleShowThirdPoll}
                            handleRemoveThirdPoll={handleRemoveThirdPoll}
                        />
                    ) : (
                        ""
                    )}

                    {/* poll length section  */}
                    <PollDueDate
                        poll={poll}
                        updatePollDays={updatePollDays}
                        updatePollHours={updatePollHours}
                        updatePollMinutes={updatePollMinutes}
                    />
                </div>
            </div>
        </div>
    );
};

export default Poll;
